<app-title-section></app-title-section>
<div class="global-header d-flex flex-column flex-sm-row align-items-start flex-wrap">
    <app-details-profil [client]="client" class="flex-grow-1"></app-details-profil>
    <app-details-factures [clientId]="client?.id" class="flex-grow-1"></app-details-factures>
    <app-details-chiffre-aff [clientId]="client?.id" class="flex-grow-1"></app-details-chiffre-aff>
    <app-details-contenue class="w-100"></app-details-contenue>
</div>

<!-- Cash Advance Modal -->
<ng-template #cashAdvanceModal let-modal>
    <div class="modal-header" style="background-color: transparent;">

        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0" style="margin: 30px 64px 64px">
        <p class="modal-title titrePop" style="text-align: center;">Avance en espèce</p>
        <p class="titre2" style="text-align: center; margin-top: 12px;">
            Veuillez indiquer le montant pour enregistrer l’avance en espèce.
        </p>
        <form #cashAdvanceForm="ngForm" (ngSubmit)="submitCashAdvance()">
            <div class="form-group">
                <label for="montant" class="form-label">Montant</label>
                <input
                        type="number"
                        class="form-control"
                        id="montant"
                        name="montant"
                        [(ngModel)]="cashAdvance.montant"
                        min="0"
                        step="0.01"
                        placeholder="Entrez le montant"
                />
            </div>
            <div class="form-group" style="margin: 24px 0">
                <label for="note" class="form-label">Note</label>
                <input
                        class="form-control"
                        id="note"
                        name="note"
                        [(ngModel)]="cashAdvance.note"
                        rows="4"
                        placeholder="Entrez une note"
                >
            </div>
            <p class="text-muted" style="font-size: 12px; margin-bottom: 16px; text-align: center;">
                * Au moins un montant ou une note doit être fourni
            </p>
            <div class="d-flex justify-content-center gap-2">
                <button type="submit" class="btn btn-primary" style="margin-right: 16px">Confirmer</button>
                <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Cancel')">Annuler</button>
            </div>
        </form>
    </div>
</ng-template>
